import Object3DNode from './Object3DNode.js';

class ModelNode extends Object3DNode {
  constructor() {
    let scope = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ModelNode.VIEW_MATRIX;
    super(scope);
  }

}

export default ModelNode;